import { faCircleUser, faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Divider, Empty, Typography } from 'antd';
import { Fragment } from 'react';

import { VisitComment } from '@app/components/VisitsHistory/components/VisitComment';
import { columns } from '@app/components/VisitsHistory/data/constants';
import type { VisitsTableType } from '@app/components/VisitsHistory/types';

import '@app/components/VisitsHistory/styles/VisitsTable.desktop.scss';
import '@app/components/VisitsHistory/styles/VisitsTable.mobile.scss';

const { Text } = Typography;
const PF = 'visits-table';

export const VisitsTable: VisitsTableType = ({
  data,
  onOpenRecord,
  onOpenRecordNewTab,
}) => (
  <div className={`${PF}_container`}>
    <table className={`${PF}_table`}>
      <thead>
        <tr>
          {columns.map(({ key, title, className, testId }) => (
            <th
              key={key}
              className={`${PF}_th ${className}`}
              data-testid={testId}
            >
              {title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.length === 0 && (
          <tr>
            <td colSpan={5} className={`${PF}_empty`}>
              <Empty />
            </td>
          </tr>
        )}
        {data.length > 0 &&
          data.map(({ date, records }) => (
            <Fragment key={date}>
              <tr>
                <td colSpan={5}>
                  <div className={`${PF}_day_cell`}>
                    <Text strong data-testid="date-of-visit">
                      {date}
                    </Text>
                  </div>
                </td>
              </tr>
              {records.map(
                (
                  {
                    id,
                    time,
                    performer,
                    statusColor,
                    statusText,
                    services,
                    paid,
                    comment,
                  },
                  index
                ) => (
                  <Fragment key={id}>
                    <tr className={`${PF}_record_row`}>
                      <td
                        className={`${PF}_record_cell ${PF}_record_cell_performer`}
                      >
                        <div className="performer-time">
                          <span className="time" data-testid="time-of-visit">
                            {time}
                          </span>
                          <FontAwesomeIcon
                            className="icon"
                            icon={faCircleUser}
                          />
                          <span
                            className="performer"
                            data-testid="performer-name"
                          >
                            {performer}
                          </span>
                        </div>
                      </td>
                      <td
                        className={`${PF}_record_cell ${PF}_record_cell_status`}
                      >
                        <div className="status">
                          <span
                            className="status-color"
                            style={{
                              backgroundColor: statusColor,
                              display:
                                !!statusColor && !!statusText
                                  ? 'block'
                                  : 'none',
                            }}
                          />
                          <span
                            className={
                              statusText ? 'status-text' : 'status-empty'
                            }
                            data-testid="visit-status"
                          >
                            {statusText ?? 'Статус неизвестен'}
                          </span>
                        </div>
                      </td>
                      <td
                        className={`${PF}_record_cell ${PF}_record_cell_services`}
                      >
                        {services.map(({ name }, idx) => (
                          <div key={idx} className="service-line">
                            <FontAwesomeIcon
                              icon={faCircle}
                              className="point"
                            />
                            <div className="name" data-testid="service-name">
                              {name}
                            </div>
                          </div>
                        ))}
                      </td>
                      <td
                        className={`${PF}_record_cell ${PF}_record_cell_cost`}
                      >
                        <div className="costs">
                          {services.map(
                            ({ cost, discount, costWithDiscount }, idx) => (
                              <div key={idx} className="cost-line">
                                <span
                                  data-testid="service-cost"
                                  className="cost"
                                >
                                  {cost.toLocaleString('ru-RU')}
                                </span>
                                {discount > 0 && (
                                  <div className="discount-info">
                                    <span
                                      data-testid="service-discount"
                                      className="discount-percent"
                                    >
                                      -{discount}%
                                    </span>
                                    <span
                                      data-testid="service-original-cost"
                                      className="original-cost"
                                    >
                                      {costWithDiscount.toLocaleString('ru-RU')}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )
                          )}
                        </div>
                      </td>
                      <td
                        className={`${PF}_record_cell ${PF}_record_cell_paid`}
                        data-testid="service-paid"
                      >
                        {paid.toLocaleString('ru-RU')}
                      </td>
                    </tr>
                    {!!comment && (
                      <tr className={`${PF}_comment_row`}>
                        <td colSpan={5}>
                          <VisitComment comment={comment} />
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td colSpan={5}>
                        <div className={`${PF}_buttons`}>
                          <Button
                            type="primary"
                            onClick={() => onOpenRecord(id)}
                            data-testid="open-visit-button"
                          >
                            Открыть запись
                          </Button>
                          <Button onClick={() => onOpenRecordNewTab(id)}>
                            Открыть в новой вкладке
                          </Button>
                        </div>
                      </td>
                    </tr>
                    {index !== records.length - 1 && (
                      <tr>
                        <td colSpan={5}>
                          <Divider className={`${PF}_divider`} />
                        </td>
                      </tr>
                    )}
                  </Fragment>
                )
              )}
            </Fragment>
          ))}
      </tbody>
    </table>
  </div>
);
